import { SubTitle, SecondaryTitle } from '../components/Title';
import Wait from '../components/Wait';
import Progress from '../components/Progress';
import { Markup } from 'interweave';
import { Box, Text } from '@enaep-ng/benchmark';
import * as styleSheet from '../styles'
import { ProgressType } from 'lib/types';

export type UpdaterContainerProps = {
  title: string;
  subTitle: string;
  progress?: ProgressType;
  message: string;
  type: 'wait' | 'progress' | 'info';
};
const UpdaterState = (props: UpdaterContainerProps) => {
  switch (props.type) {
    case 'wait':
      return (
        <Box sx={styleSheet.updaterCommonContainer}>
          <SecondaryTitle content={props.title} />
          <Wait />
          <Text sx={styleSheet.textStyled}><Markup content={props.message} /></Text>
          <Text sx={{...styleSheet.textStyled, fontWeight: 'bold'}}><Markup content={props.subTitle} /></Text>
          {/* <SubTitle content={props.subTitle} /> */}
        </Box>
      );
    case 'info':
      return (
        <Box sx={styleSheet.updaterCommonContainer}>
          <SecondaryTitle
            content={props.title}
            style={styleSheet.updaterSecondaryTitle}
          />
          <SubTitle content={props.subTitle} />
        </Box>
      );
    case 'progress':
      return (
        <Box>
          <SecondaryTitle
            content={props.title}
            style={styleSheet.updaterSecondaryTitle}
          />
          <SubTitle
            content={props.subTitle}
            style={styleSheet.updaterSubTitle}
          />
          {props?.progress && <Progress {...props.progress} />}
          <Markup content={props.message} />
        </Box>
      );
  }
};

const Updater = (props: UpdaterContainerProps) => {
  return (
    <Box sx={styleSheet.updaterCommonContainer}>
      {UpdaterState(props)}
    </Box>
  );
};
export default Updater;
